import { styled } from '@mui/material/styles';
import React from 'react';

import VerantosBackground from './verantos-background.png';
import Logo from './verantos-logo-only.svg';

export type LoadingProps = {
  style?: React.CSSProperties;
};

const StyledLoading = styled('div')({
  height: '100vh',
  width: '100vw',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundImage: `url(${VerantosBackground})`,
  backgroundSize: 'cover',
});

const StyledLogo = styled('img')({
  width: '100px',
  height: '100px',
  animationName: 'ckw',
  animationDuration: '15.5s',
  animationIterationCount: 'infinite',
  transformOrigin: '50% 50%',
  display: 'inline-block',
  '@keyframes ckw': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
});

export const Loading = ({ style }: LoadingProps) => {
  return (
    <StyledLoading style={style}>
      <StyledLogo src={Logo} alt="loading" data-testid="loading" />
    </StyledLoading>
  );
};
